import { createSlice } from '@reduxjs/toolkit';

interface IQuickFormSliceState {
  isOpenQuickTasks: boolean;
  isOpenQuickComments: boolean;
  isOpenQuickContact: boolean;
}

const initialState: IQuickFormSliceState = {
  isOpenQuickTasks: false,
  isOpenQuickComments: false,
  isOpenQuickContact: false,
};

export const quickFormsSlice = createSlice({
  name: 'quickForms',
  initialState,
  reducers: {
    toggleQuickTasks: (state) => {
      state.isOpenQuickTasks = !state.isOpenQuickTasks;
    },
    toggleQuickComments: (state) => {
      state.isOpenQuickComments = !state.isOpenQuickComments;
    },
    toggleQuickContact: (state) => {
      state.isOpenQuickContact = !state.isOpenQuickContact;
    },
  },
});

export const { toggleQuickTasks, toggleQuickComments, toggleQuickContact } = quickFormsSlice.actions;
